import { setAllDevices, setPreferredDevice, setDriveDevices } from 'devices';

export const processDeviceList = ({ dispatch, deviceList }) => {
  dispatch(setAllDevices(deviceList));
  return Promise.resolve(deviceList);
};

export const processPreferredDevice = ({ dispatch, preferredDevice }) => {
  dispatch(setPreferredDevice(preferredDevice));
  return Promise.resolve(preferredDevice);
};

export const processDriveDevices = ({ dispatch, driveDevices }) => {
  dispatch(setDriveDevices(driveDevices));
  return Promise.resolve(driveDevices);
};